export default "<div class=\"spinner-wrapper\">\n    <app-spinner [message]=\"message\"></app-spinner>\n</div>";